import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["iconData", "height", "width", "onIconSelect", "color", "display"];
import { PureComponent } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import styled from 'styled-components';
import { OBSIDIAN } from 'HubStyleTokens/colors';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSvg = styled.svg.withConfig({
  displayName: "Icon__StyledSvg",
  componentId: "sc-6bqj10-0"
})(({
  iconHeight: height,
  iconWidth: width
}) => {
  return {
    height,
    width,
    display: 'block'
  };
});
class Icon extends PureComponent {
  render() {
    const _this$props = this.props,
      {
        iconData,
        height,
        width,
        onIconSelect,
        color,
        display
      } = _this$props,
      spaceStyleProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      name,
      svg,
      viewPort
    } = iconData;
    const renderedSvg = /*#__PURE__*/_jsx(StyledSvg, {
      iconHeight: height,
      iconWidth: width,
      viewBox: viewPort ? viewPort.join(' ') : '',
      role: "img",
      "aria-label": name,
      children: /*#__PURE__*/_jsx("path", {
        fill: color,
        d: svg
      })
    });
    return display === 'flex' ? /*#__PURE__*/_jsx(Flex, Object.assign({
      "data-test-id": "cmv2-icon",
      "data-value": name,
      onClick: () => onIconSelect(iconData)
    }, spaceStyleProps, {
      children: renderedSvg
    })) : /*#__PURE__*/_jsx(View, Object.assign({
      "data-test-id": "cmv2-icon",
      "data-value": name,
      onClick: () => onIconSelect(iconData),
      display: display
    }, spaceStyleProps, {
      children: renderedSvg
    }));
  }
}
Icon.defaultProps = {
  height: 25,
  width: 25,
  color: OBSIDIAN,
  onIconSelect: emptyFunction
};
export default Icon;